import styled from 'styled-components';

import typographyCss, { FontWeight } from './typographyCss';

const Heading1 = styled.h1`
  margin-block-start: 0;
  margin-block-end: 0;
  ${typographyCss.Heading1}
`;

const Heading2 = styled.h2`
  margin-block-start: 0;
  margin-block-end: 0;
  ${typographyCss.Heading2}
`;

const Heading3 = styled.h3`
  margin-block-start: 0;
  margin-block-end: 0;
  ${typographyCss.Heading3}
`;

const Heading4 = styled.h4`
  margin-block-start: 0;
  margin-block-end: 0;
  ${typographyCss.Heading4}
`;

const Heading5 = styled.h5`
  margin-block-start: 0;
  margin-block-end: 0;
  ${typographyCss.Heading5}
`;

const Heading6 = styled.h6`
  margin-block-start: 0;
  margin-block-end: 0;
  ${typographyCss.Heading6}
`;

const Title1 = styled.span`
  ${typographyCss.Title1}
`;

const Title2 = styled.span`
  ${typographyCss.Title2}
`;

const Subtitle = styled.span`
  ${typographyCss.Subtitle}
`;

const Body1 = styled.span<{ fontWeight?: FontWeight }>`
  ${typographyCss.Body1}
`;

const Body2 = styled.span<{ fontWeight?: FontWeight }>`
  ${typographyCss.Body2}
`;

const Body3 = styled.span<{ fontWeight?: FontWeight }>`
  ${typographyCss.Body3}
`;

const Small = styled.span`
  ${typographyCss.Small}
`;

const Tiny = styled.span`
  ${typographyCss.Tiny}
`;

const Overline1 = styled.span`
  ${typographyCss.Overline1}
`;

const Overline2 = styled.span`
  ${typographyCss.Overline2}
`;

const Overline3 = styled.span`
  ${typographyCss.Overline3}
`;

const Overline4 = styled.span`
  ${typographyCss.Overline4}
`;

const Quote1 = styled.span`
  ${typographyCss.Quote1}
`;

const Quote2 = styled.span`
  ${typographyCss.Quote2}
`;

export {
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  Title1,
  Title2,
  Subtitle,
  Body1,
  Body2,
  Body3,
  Small,
  Tiny,
  Overline1,
  Overline2,
  Overline3,
  Overline4,
  Quote1,
  Quote2,
};
